import { useMemo } from 'react';
import { ErrorBoundary, Layout, HomepageLayout } from '@/components';
import HomePage from '@/pages';
import NetworkPage from '@/pages/network';
import MarketPage from '@/pages/network/marketAddress';
import MarketEventsPage from '@/pages/network/marketAddress/events';
import SupplyWalletsPage from '@/pages/network/marketAddress/suppliers';
import SupplyWalletPage from '@/pages/network/marketAddress/suppliers/wallet';
import SupplyWalletEventsPage from '@/pages/network/marketAddress/suppliers/wallet/events';
import BorrowWalletsPage from '@/pages/network/marketAddress/borrowers';
import BorrowWalletPage from '@/pages/network/marketAddress/borrowers/wallet';
import BorrowWalletEventsPage from '@/pages/network/marketAddress/borrowers/wallet/events';
import LiquidationsPage from '@/pages/network/marketAddress/liquidations';
import CollateralBuyers from '@/pages/network/marketAddress/liquidations/buyers';
import CollateralBuyer from '@/pages/network/marketAddress/liquidations/buyers/buyer';
import CollateralPage from '@/pages/network/marketAddress/collateralAddress';
import CollateralEventsPage from '@/pages/network/marketAddress/collateralAddress/events';
import SuppliersPage from '@/pages/network/marketAddress/collateralAddress/suppliers';
import { createBrowserRouter, RouteObject } from 'react-router';
import { NETWORKS } from '@/constants';
import { RouterProvider } from 'react-router';
import { OldRedirect } from './oldRouter';

function buildAllNetworkRoutes(routes: RouteObject[]) {
  const allRoutes: RouteObject[] = [];

  NETWORKS.forEach((network) => {
    allRoutes.push(
      ...routes.map((route) => ({ ...route, path: `/${network}${route.path}` }))
    );
  });
  return allRoutes;
}

export default function Router() {
  const ROUTES: RouteObject[] = useMemo(
    () => [
      {
        path: '/:marketAddress',
        element: <MarketPage />
      },
      {
        path: '/:marketAddress/activity',
        element: <MarketEventsPage />
      },
      {
        path: '/:marketAddress/suppliers',
        element: <SupplyWalletsPage />
      },
      {
        path: '/:marketAddress/suppliers/:walletAddress',

        element: <SupplyWalletPage />
      },
      {
        path: '/:marketAddress/suppliers/:walletAddress/activity',
        element: <SupplyWalletEventsPage />
      },
      {
        path: '/:marketAddress/borrowers',
        element: <BorrowWalletsPage />
      },
      {
        path: '/:marketAddress/borrowers/:walletAddress',

        element: <BorrowWalletPage />
      },
      {
        path: '/:marketAddress/borrowers/:walletAddress/activity',
        element: <BorrowWalletEventsPage />
      },
      {
        path: '/:marketAddress/liquidations',
        element: <LiquidationsPage />
      },
      {
        path: '/:marketAddress/liquidations/collateral-buyers',
        element: <CollateralBuyers />
      },
      {
        path: '/:marketAddress/liquidations/collateral-buyers/:walletAddress',
        element: <CollateralBuyer />
      },
      {
        path: '/:marketAddress/:collateralAddress',
        element: <CollateralPage />
      },
      {
        path: '/:marketAddress/:collateralAddress/activity',
        element: <CollateralEventsPage />
      },
      {
        path: '/:marketAddress/:collateralAddress/wallets',
        element: <SuppliersPage />
      }
    ],
    []
  );

  ////////////////////////////////////////////////
  // REDIRECTS THAT HANDLE URLS FROM OLD DASHBOARD
  ////////////////////////////////////////////////
  const OLD_ROUTES: RouteObject[] = useMemo(
    () => [
      {
        path: '/v3/ethereum/:market',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/markets',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/markets/:collateral',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/wallets',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/wallets/:wallet',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/liquidations',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/collateral-buyers/:collateralBuyer',
        element: <OldRedirect />
      },
      {
        path: '/v3/ethereum/:market/activity',
        element: <OldRedirect />
      }
    ],
    []
  );

  const router = createBrowserRouter([
    {
      element: <Layout />,
      errorElement: (
        <Layout>
          <ErrorBoundary />
        </Layout>
      ),
      children: buildAllNetworkRoutes(ROUTES)
    },
    {
      element: <HomepageLayout />,
      children: [
        {
          path: '/',
          element: <HomePage />
        },
        ...NETWORKS.map((network) => ({
          path: `/${network}`,
          element: <NetworkPage />
        })),
        ...OLD_ROUTES
      ]
    }
  ]);

  return <RouterProvider router={router} />;
}
